export const ru = {
    'expander-error': 'Прогноз временно недоступен',
    'expander-header': 'Добавьте баннеры',
    'expander-no-data':
        'Отключите или расширьте некоторые характеристики профиля пользователей',
    'id-predictor': 'ID прогноза {id}',
    increase: 'Увеличить охват'
};
